import React from 'react';
import moment from 'moment-timezone';
import { FiClock } from 'react-icons/fi';
import { Accordion } from '@/components/Accordion';
import { SessionSourceTags } from '@/components/SessionSourceTags';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { formatTimeFromSeconds } from '@/utils/timeUtils';
import styles from './SessionAccordionCard.module.scss';

const ICON_PALETTE = ['blue', 'success', 'purple', 'orange'];

export const SessionAccordionCardComponent = ({
  session,
  index,
  selectedTimezone,
  children,
}) => {
  const startTime = moment(session.start)
    .tz(selectedTimezone)
    .format('hh:mm A');
  const endTime = session.end
    ? moment(session.end).tz(selectedTimezone).format('hh:mm A')
    : 'Ongoing';
  const color =
    ICON_PALETTE[
      ((index % ICON_PALETTE.length) + ICON_PALETTE.length) %
        ICON_PALETTE.length
    ];

  return (
    <div className={styles.sessionCard}>
      <Accordion
        contentClassName={styles.accordionContent}
        heading={
          <div className={styles.sessionHeading}>
            <span className={styles.sessionIcon} data-color={color}>
              <FiClock size={14} />
            </span>
            <Text
              variant={textVariantsEnum.Display_xs}
              fontWeight={fontWeightEnum.Semibold}
              color="gray-900"
            >
              {startTime} - {endTime}
            </Text>
            <SessionSourceTags
              pastData={session?.pastData}
              typeLog={session?.typeLog}
            />
            <div className={styles.totalDuration}>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="gray-500"
              >
                Total Duration:
              </Text>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Semibold}
                color="blue-600"
              >
                {formatTimeFromSeconds(session.durationSec)}
              </Text>
            </div>
          </div>
        }
      >
        {children}
      </Accordion>
    </div>
  );
};

SessionAccordionCardComponent.displayName = 'SessionAccordionCard';
